import { GeoJSONFeatureCollection, AvailableRoutesResponse } from '../types';
const baseUrl = process.env.BACKEND_BASE_URL || 'https://routing-lab-api.sebastianoes.ch';

const routeEndpoints = {
    availableRoutes: '/available_routes', // Endpoint to get available routes
    routesGeoJSON: '/routes_geojson', // Endpoint to get GeoJSON based on parameters
    preprocessedRoutes: '/preprocessed_routes', // Endpoint to get preprocessed routes
    schoolsGeoJSON: '/schools_geojson', // Endpoint to get schools GeoJSON
};

// Get list of available routes, preprocessed counts and cities from backend
export const getAvailableRoutes = async (): Promise<AvailableRoutesResponse> => {
    try {
        const response = await fetch(
            `${baseUrl}${routeEndpoints.availableRoutes}`
        );
        if (!response.ok) {
            throw new Error(`Failed to fetch available routes: ${response.statusText}`)
        }
        const data: AvailableRoutesResponse = await response.json()
        return data;
    } catch (error) {
        console.error('Error fetching available routes:', error);
        throw error;
    }
};

export const getRoutes = async (city: string, routes: string[], number: number): Promise<GeoJSONFeatureCollection> => {
    try {
        const payload = {
            city: city,
            requested_routes: routes,
            num_routes: number
        };
        const response = await fetch(`${baseUrl}${routeEndpoints.routesGeoJSON}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch routes: ${response.statusText}`)
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching routes:', error);
        throw new Error('Failed to fetch routes');
    }
};

export const getPreprocessedRoutes = async (city: string, number: number): Promise<GeoJSONFeatureCollection> => {
    try {
        const payload = {
            city: city,
            num_routes: number
        };
        const response = await fetch(`${baseUrl}${routeEndpoints.preprocessedRoutes}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch preprocessed routes: ${response.statusText}`)
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching preprocessed routes:', error);
        throw new Error('Failed to fetch preprocessed routes');
    }
};

export const getSchools = async (city: string): Promise<GeoJSONFeatureCollection> => {
    try {
        const payload = {
            city: city
        };
        const response = await fetch(`${baseUrl}${routeEndpoints.schoolsGeoJSON}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch schools: ${response.statusText}`)
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching schools:', error);
        throw new Error('Failed to fetch schools');
    }
}
